import { render } from "./LoginFrom.vue?vue&type=template&id=1cef4e04&scoped=true"
import script from "./LoginFrom.vue?vue&type=script&lang=js"
export * from "./LoginFrom.vue?vue&type=script&lang=js"

import "./LoginFrom.vue?vue&type=style&index=0&id=1cef4e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cef4e04"]])

export default __exports__